var React = require('react');

function IconTickGreenBg (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Group 172"},[React.createElement("circle",{"id":"Ellipse 3","cx":"10","cy":"10","r":"10","fill":"#C5E3C1","key":0}),React.createElement("path",{"id":"Union","fillRule":"evenodd","clipRule":"evenodd","d":"M13.1213 6.53553L8.17157 11.4853L6.05025 9.36396C5.65973 8.97344 5.02656 8.97344 4.63604 9.36396C4.24551 9.75449 4.24551 10.3877 4.63604 10.7782L6.75736 12.8995L8.17157 14.3137L9.58579 12.8995L14.5355 7.94975C14.9261 7.55922 14.9261 6.92606 14.5355 6.53553C14.145 6.14501 13.5118 6.14501 13.1213 6.53553Z","fill":"#001D3B","key":1})]));
}

IconTickGreenBg.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = IconTickGreenBg;

IconTickGreenBg.default = IconTickGreenBg;
